/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Page_AboutInputs */

const en_us2_profile_page_about = /** @type {(inputs: Profile_Page_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About you`)
};

const pt_br2_profile_page_about = /** @type {(inputs: Profile_Page_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre você`)
};

const es_419_profile_page_about = /** @type {(inputs: Profile_Page_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre ti`)
};

const pt_pt2_profile_page_about = /** @type {(inputs: Profile_Page_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre ti`)
};

const fr_fr2_profile_page_about = /** @type {(inputs: Profile_Page_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos de toi`)
};

const de_de2_profile_page_about = /** @type {(inputs: Profile_Page_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über dich`)
};

const it_it2_profile_page_about = /** @type {(inputs: Profile_Page_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su di te`)
};

/**
* | output |
* | --- |
* | "About you" |
*
* @param {Profile_Page_AboutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_page_about = /** @type {((inputs?: Profile_Page_AboutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Page_AboutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_page_about(inputs)
	if (locale === "es-419") return es_419_profile_page_about(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_page_about(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_page_about(inputs)
	if (locale === "de-DE") return de_de2_profile_page_about(inputs)
	if (locale === "it-IT") return it_it2_profile_page_about(inputs)
	return en_us2_profile_page_about(inputs)
});
export { profile_page_about as "profile.page_about" }